export default "__VITE_ASSET__036016fb__"